import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { LoginResponse } from './Interfaces/LoginResponse';
import ApiRequest from '../../Decorators/ApiRequest';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';

const BASE_URL = import.meta.env.VITE_BASE_URL_LINK;

export class LoginGateway {
    async login(email: string): Promise<ApiResult<LoginResponse>> {
        try {
            const response = await ApiRequest(
                `${BASE_URL}/login_cashbuild`,
                {
                    method: 'POST',
                    headers: API_DEFAULT_HEADERS,
                    body: JSON.stringify({ email }),
                },
                false
            );

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to get token for login',
                };
            }

            const json: LoginResponse = await response.json();
            return {
                error: false,
                data: json,
            };
        } catch (error) {
            return {
                error: true,
                message: `Failed to fetch token: ${(error as Error).message}`,
            };
        }
    }
}
